import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable, of, switchMap} from 'rxjs';
import { AuthService } from '../services/auth.service';
import { RoleConstants } from '../constants/role.constants';
import {CommonService} from '../api/services/utility-services/common.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    // First check if user is authenticated
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/login'], {
        queryParams: { returnUrl: state.url }
      });
      return of(false);
    }

    // Get required roles from route data
    const requiredRoles = route.data['roles'] as string[];

    if (!requiredRoles || requiredRoles.length === 0) {
      // No roles required, allow access
      return of(true);
    }



    return of(true);
  }
}

// Specific role guards for common use cases
@Injectable({
  providedIn: 'root'
})
export class CustomerGuard implements CanActivate {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly commonService = inject(CommonService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {

    return this.commonService.session().pipe(switchMap(session => {

      const validlogin = !!(session && session.sessionId && session.userName);

      if (validlogin && this.authService.isCustomer()) {
        return of(true);
      }
      if (validlogin && !this.authService.isCustomer()) {
        this.router.navigate(['/unauthorized']);
        return of(false);
      }
      else {
        this.router.navigate(['/login'], {
          queryParams: { returnUrl: state.url }
        });
        return of(false);
      }
    }));
  }
}

@Injectable({
  providedIn: 'root'
})
export class PartnerGuard implements CanActivate {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly commonService = inject(CommonService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {

    return this.commonService.session().pipe(switchMap(session => {

      const validlogin = !!(session && session.sessionId && session.userName);

      if (validlogin && this.authService.isPartner()) {
        return of(true);
      }
      if (validlogin && !this.authService.isPartner()) {
        this.router.navigate(['/unauthorized']);
        return of(false);
      }
      else {
        this.router.navigate(['/login'], {
          queryParams: { returnUrl: state.url }
        });
        return of(false);
      }
    }));
  }
}

@Injectable({
  providedIn: 'root'
})
export class CustomerSuperUserGuard implements CanActivate {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly commonService = inject(CommonService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.commonService.session().pipe(switchMap(session => {

      const validlogin = !!(session && session.sessionId && session.userName);

      if (validlogin && this.authService.isCustomerSuperUser()) {
        return of(true);
      }
      if (validlogin && !this.authService.isCustomerSuperUser()) {
        this.router.navigate(['/unauthorized']);
        return of(false);
      } else {
        this.router.navigate(['/login'], {
          queryParams: {returnUrl: state.url}
        });
        return of(false);
      }
    }));
  }
}
